import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Tool } from '@/data/tools';
import { ToolIcon } from './tools/ToolIcon';

interface MegaMenuCategoryProps {
    categoryName: string;
    tools: Tool[];
    showHeader?: boolean;
    onToolClick?: () => void;
}

export default function MegaMenuCategory({ categoryName, tools, showHeader = true, onToolClick }: MegaMenuCategoryProps) {
    const navigate = useNavigate();

    if (tools.length === 0) return null;

    return (
        <div className="mb-6">
            {showHeader && (
                <h3 className="text-sm font-bold text-gray-900 mb-3 px-2">{categoryName}</h3>
            )}
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-2">
                {tools.map((tool) => (
                    <button
                        key={tool.id}
                        onClick={() => {
                            navigate(tool.route);
                            onToolClick?.();
                        }}
                        className="flex items-start gap-3 p-3 rounded-lg hover:bg-gray-50 transition-colors text-left group"
                    >
                        <div className="p-2 rounded-lg flex-shrink-0 bg-blue-50 text-blue-600 group-hover:bg-blue-100">
                            <ToolIcon icon={tool.icon} size={18} />
                        </div>
                        <div className="flex-1 min-w-0">
                            <div className="flex items-center gap-2">
                                <span className="text-sm font-semibold text-gray-900 group-hover:text-blue-600 transition-colors">
                                    {tool.name}
                                </span>
                            </div>
                            <p className="text-xs text-gray-500 mt-0.5 line-clamp-1">
                                {tool.description}
                            </p>
                        </div>
                    </button>
                ))}
            </div>
        </div>
    );
}
